module.exports = __webpack_public_path__ + "static/media/video-letgo-ms.4e4199ef.vtt";